var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminatePaperCompliance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2035 25.4957L27.89 30.7198L45.3035 8.43149",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2683 24.5559L46.9745 38.4516C47.1038 39.5045 46.8095 40.5657 46.1564 41.4017C45.5032 42.2377 44.5447 42.7799 43.4918 42.9092L15.7005 46.3216C14.6475 46.4509 13.5863 46.1566 12.7504 45.5034C11.9144 44.8503 11.3721 43.8918 11.2428 42.8389L7.83049 15.0476C7.70121 13.9946 7.9955 12.9334 8.64864 12.0975C9.30177 11.2615 10.2602 10.7192 11.3132 10.5899L33.1492 7.90879",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminatePaperCompliance);
export default __webpack_public_path__ + "static/media/eliminate-paper-compliance.389c2a3374997d57379df45fe5502bc7.svg";
export { ForwardRef as ReactComponent };